import { ReactNode } from "react";
import { useAuth } from "@/hooks/use-auth";
import { usePermission } from "@/hooks/use-permission";
import { LoadingPage } from "@/components/common/loading";
import NotAuthorized from "@/pages/not-authorized";

interface RequireFeatureProps {
  feature: string;
  permission: string;
  children: ReactNode;
}

export function RequireFeature({
  feature,
  permission,
  children,
}: RequireFeatureProps) {
  const { isLoading } = useAuth();
  const allowed = usePermission(feature, permission);

  if (isLoading) return <LoadingPage />;
  return allowed ? <>{children}</> : <NotAuthorized />;
}
